module.exports = __webpack_public_path__ + "img/encina-login.c206925e.png";